<template>
  <div>
    <div class="d-flex flex-column h-100">
      <div>
        <SystemBar />
      </div>
      <div class="flex-fill overflow-auto">
        <div
          v-if="room.loading"
          class="px-6 py-10"
        >
          <Loading message="Buscando trasmisiones disponibles. Por favor espere..." />
        </div>
        <div
          v-else-if="room.data._id"
          class="relative"
        >
          <div
            class="d-flex align-center px-2 py-2 bg-top-gradient pb-6"
            :class="display.show ? 'show' : ''"
            :style="'position: fixed; width: 100%; z-index: 2'"
          >
            <div>
              <v-btn
                icon
                small
                @click="goBack"
                class="mr-2"
              >
                <Icon
                  :width="18"
                  :color="'#fff'"
                  :icon="'arrow-left'"
                />
              </v-btn>
            </div>
            <div class="flex-fill mr-2">
              <Detail :room="room.data" />
            </div>
            <div>
              <Summary
                color="white"
                :room="room.data"
                @cellphoneMode="cellphoneMode"
                :video="video"
              />
            </div>
          </div>
          <div>
            <Player
              :room="room.data"
              :video="video"
              :isIos="!isIos"
              @offAudioStream="offAudioStream"
              :post="selectedPost"
              :customer="customer.data"
              @setCustomer="customer.show = true"
              @showPost="showPost"
            />
          </div>

          <div
            class="more-btn bg-bottom-gradient"
            :class="display.show ? 'show' : ''"
            v-show="!selectedPost || (selectedPost && !selectedPost.visible)"
          >
            <Options
              :organization="organization"
              @cellphoneMode="cellphoneMode"
              @toggleMute="toggleMute"
              :video="video"
              :display="display"
              :incomplete="incomplete"
              :customer="customer.data"
              :room="room.data"
              :isIos="!isIos"
              :configStreamer="configStreamer"
              @setCustomer="customer.show = true"
              @showPost="showPost"
            />
          </div>

          <!-- <v-bottom-sheet
            v-model="chat.config.visible"
            overlay-opacity="0"
            fullscreen
            transition="scroll-x-reverse-transition"
          >
            <v-sheet
              class="float-end"
              height="100vh"
              width="90%"
            >
              <Chat
                :room="room.data"
                :customer="customer.data"
                @hideChat="chat.config.visible = false"
              />
            </v-sheet>
          </v-bottom-sheet> -->
          <div class="customer-backdrop">
            <v-sheet
              v-if="customer.show"
              rounded
              class="customer"
            >
              <Customer
                :loadingButton="customer.loading"
                @hideCustomer="customer.show = false"
                @saveCustomer="updateViewer"
                :requiredData="requiredData"
                :room="room"
                :customer="customer.data"
              />
            </v-sheet>
          </div>
        </div>
        <div v-else>
          <Empty @goBack="goBack" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

import MainStreamingService from '@/services/MainStreamingService'

require('@/services/Rooms')

@Component({
  components: {
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    Summary: () => import(/* webpackPrefetch: true */ '@/views/room/components/Summary.vue'),
    Detail: () => import(/* webpackPrefetch: true */ '@/views/room/components/Detail.vue'),
    Player: () => import(/* webpackPrefetch: true */ '@/views/room/components/Player.vue'),
    Customer: () => import(/* webpackPrefetch: true */ '@/views/room/components/Customer.vue'),
    Chat: () => import(/* webpackPrefetch: true */ '@/views/room/components/chat/Index.vue'),
    MessagesPreview: () => import(/* webpackPrefetch: true */ '@/views/room/components/chat/components/MessagesPreview.vue'),
    Options: () => import(/* webpackPrefetch: true */ '@/views/room/components/Options.vue'),
    Loading: () => import(/* webpackPrefetch: true */ '@/components/Loading.vue'),
    Empty: () => import(/* webpackPrefetch: true */ '@/views/room/show/Empty.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  computed: {
    roomId () {
      return this.$route.params.roomId
    },
    rooms () {
      return this.$store.state.rooms.list.data
    },
    room () {
      return this.$store.state.rooms.item
    },
    chat () {
      return this.$store.state.rooms.item.chat
    },
    organization () {
      return this.$store.state.organization.item
    },
    isIos () {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }
  },
  watch: {
    rooms: function (rooms) {
      const room = rooms.find((room) => room.session && room.session.id === this.room.data._id)

      if (!room) {
        this.$router.replace({ path: '/rooms' })
      }
    }
  }
})
export default class Index extends Vue {
  data () {
    return {
      customer: {
        data: null,
        show: false,
        loading: false
      },
      video: {
        audio: true
      },
      display: {
        interval: null,
        show: false
      },
      configStreamer: null,
      requiredData: {
        name: false,
        email: false,
        identification: false
      },
      incomplete: false,
      selectedPost: null
    }
  }

  toggleMute () {
    this.video.audio = !this.video.audio
  }

  offAudioStream () {
    this.video.audio = false
  }

  cellphoneMode () {
    this.room.data.cellPhoneMode = !this.room.data.cellPhoneMode
  }

  showPost (selectedPost) {
    this.selectedPost = selectedPost
  }

  join () {
    if (!this.room.data._id) {
      return false
    }

    const device = this.$widget.getDevice()
    this.getCustomer()

    if (this.customer.data) {
      device.user = {
        name: this.customer.data.name ? this.customer.data.name : null,
        email: this.customer.data.email ? this.customer.data.email : null,
        identification: this.customer.data.identification ? this.customer.data.identification : null
      }
    }

    device.location = this.$cityMap.country

    const joinData = {
      id: this.$store.state.widget.uuid,
      sessionId: this.room.data._id,
      device
    }

  }

  saveCustomer (customer) {
    let customerStorage = {
      name: null,
      email: null,
      identification: null,
      id: null
    }

    if (this.$store.state.storage.room.customer) {
      customerStorage = Object.assign(customerStorage, this.$store.state.storage.room.customer)
    } else {
      this.$store.state.storage.room.customer = customerStorage
    }

    for (const field in customerStorage) {
      if (Object.hasOwnProperty.call(customerStorage, field)) {
        const element = customerStorage[field]
        if (!customerStorage[field]) {
          this.$store.state.storage.room.customer[field] = customer[field]
        }
      }
    }

    this.$storage.updateStorageData()

    this.customer.data = this.$store.state.storage.room.customer

    this.customer.show = false
    this.video.audio = true
    this.incomplete = false
  }

  async updateViewer (customer) {
    this.customer.loading = true

    const data = {
      route: '/viewers',
      params: {
        id: this.$store.state.widget.uuid,
        sessionId: this.roomId,
        device: {
          user: {
            name: customer.name,
            email: customer.email,
            identification: customer.identification
          }
        }
      }
    }

    return MainStreamingService.post(data)
      .then((response) => {
        const res = response ? response.data : null

        if (res && res.statusCode === 0) {
          customer.id = res.data.customer_id
          this.saveCustomer(customer)
        }
      })
      .catch((e) => {
        console.log(e)
      })
      .then(() => {
        this.customer.loading = false
      })
  }

  beforeDestroy () {
    const data = {
      sessionId: this.room.data._id,
      viewerId: this.room.viewer._id
    }

    this.$store.state.rooms.item.chat.messages = []
    this.hideChat()
  }

  hideChat () {
    this.chat.config.visible = false
    this.chat.unreadMessages = false
  }

  goBack () {
    this.$router.replace({ path: '/rooms' })
  }

  setIncompleteData (customer, attribute, streamConfig) {
    this.customer.data = {
      name: customer.name ?? null,
      email: customer.email ?? null,
      identification: customer.identification ?? null,
      id: customer.id ?? null
    }

    for (const key in this.customer.data) {
      if (Object.hasOwnProperty.call(this.customer.data, key)) {
        const element = this.customer.data[key]

        attribute.map((item) => {
          if (key === item.name && !element) {
            this.requiredData[key] = item
            this.incomplete = true
          }
        })
      }
    }

    if (this.incomplete) {
      this.customer.show = true
      this.offAudioStream()
    }
  }

  getCustomer () {
    const isTimer = true
    const customer = this.$store.state.storage.room.customer
    if (!this.configStreamer) {
      this.configStreamer = this.room.data
    }
    const streamConfig = this.configStreamer
    const attribute = streamConfig && streamConfig.form_fields.length
      ? streamConfig.form_fields
      : [
          {
            name: 'name',
            required: true
          },
          {
            name: 'email',
            required: true
          }
        ]

    if (streamConfig.data_rule === 'required') {
      if (customer) {
        this.setIncompleteData(customer, attribute, streamConfig)
      } else {
        setTimeout(() => {
          this.offAudioStream()
        }, 200);
        attribute.map((item) => {
          this.requiredData[item.name] = item
        })

        this.incomplete = true
        this.customer.show = true
      }
    } else {
      if (customer) {
        this.setIncompleteData(customer, attribute, streamConfig)
      } else {
        setTimeout(() => {
          this.offAudioStream()
        }, 200);
        this.incomplete = true
        attribute.map((item) => {
          this.requiredData[item.name] = item
        })
      }
    }
  }

  displayInterval () {
    this.display.interval = setInterval(() => {
      if (!this.display.show) {
        return false
      }

      if (this.display.show) {
        this.display.show = false
      }
    }, 4000)
  }

  async mounted () {
    await this.$rooms
      .find(this.roomId)
      .then(() => {
        this.join()
      })
      .catch(() => {
        this.$router.replace({ path: '/rooms' })
      })
  }
}
</script>

<style>
  .bg-top-gradient {
    background: rgb(87, 87, 87);
    background: linear-gradient(180deg, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0) 100%);
  }

  .bg-bottom-gradient {
    background: rgb(87, 87, 87);
    background: linear-gradient(360deg, rgb(0, 0, 0) 0%, rgba(255, 255, 255, 0) 100%);
  }

  .more-btn {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 3;
    width: 100%;
  }

  .chat-btn-badge span.v-badge__badge {
    opacity: 0;
    transform: scale(0);
  }

  .chat-btn-badge.active-badge .v-badge__wrapper span.v-badge__badge {
    opacity: 1;
    transform: scale(1);
  }

  #chat-preview {
    position: absolute;
    bottom: 170px;
    transition: all 0.2s;
    width: 100%;
  }

  #chat-preview.bottom-regular {
    bottom: 60px;
  }

  #chat-preview.bottom-none {
    bottom: 60px;
  }

  #chat-preview.bottom-regular.bottom-none {
    bottom: 60px;
  }

  #posts-container {
    max-width: calc(100% - 16px);
    z-index: 2;
    overflow: auto;
    transition: all 0.2s;
  }

  #posts-container.bottom-none {
    bottom: 5px;
  }

  #posts-container::-webkit-scrollbar {
    width: 3px !important;
    height: 5px !important;
  }

  #posts-container::-webkit-scrollbar-track {
    background-color: rgba(163, 163, 163, 0.514);
    padding: 10px;
  }

  #posts-container::-webkit-scrollbar-thumb {
    background-color: rgb(161, 161, 161);
    border-radius: 10px;
    padding: 10px;
    transition: all 0.2s;
  }

  #posts-container::-webkit-scrollbar-thumb:hover {
    background-color: rgb(191, 191, 191);
  }

  .customer {
    margin: 30% 10px 0;
  }

  .customer-backdrop {
    position: absolute;
    background: #0006;
    bottom: 0px;
    height: 94%;
    z-index: 9;
  }
</style>
